import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from '../../../environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (!environment.production && 'serviceWorker' in navigator) {

      navigator.serviceWorker.getRegistration().then(reg => {
        console.log('[MAIN] Service Worker Registration', reg);
      });

      navigator.serviceWorker.ready.then(reg => {
        console.log('[MAIN] Service Worker Ready', reg);
      });

    }
  })
  .catch(err => console.error(err));